import {Injectable} from '@angular/core';
import {map} from 'rxjs/operators';
import {BasicEpic} from './basic.epic';
import {PollActions} from '../actions/poll.actions';
import {PollService} from '../services/poll.service';
import {EventService, LoggerService, StoreActionsEnum} from '../../../modules/hbs-services';

@Injectable()
export class ScriptQuestSetsEpics extends BasicEpic {

    protected epicNames = [
        'replaceAllScriptQuestSets',
        'replaceAllScriptsAndScriptQuestSets'
    ];

    constructor(private pollService: PollService,
                private eventService: EventService,
                private logger: LoggerService) {
        super();
    }

    private replaceAllScriptQuestSets = BasicEpic.createEpic(
        StoreActionsEnum.UPDATE_ALL_SCRIPTQUESTSETS,
        ({payload}) => {
            this.logger.log('storage@QuestionEpics: replaceAllScriptQuestSets', payload);
            return this.pollService
                .replaceAllScriptQuestSets(payload.scriptQuestSets,
                    payload.questNumPairs, payload.keepResponses, payload.pollId)
                .pipe(
                    map(PollActions.scriptQuestSetsUpdated)
                );
        });

    private replaceAllScriptsAndScriptQuestSets = BasicEpic.createEpic(
        StoreActionsEnum.REPLACE_ALL_SCRIPTS_AND_SCRIPTQUESTSETS,
        ({payload}) => {
            this.logger.log('storage@QuestionEpics: replaceAllScriptsAndScriptQuestSets', payload);
            return this.pollService
                .replaceAllScriptsAndScriptQuestSets(payload.scripts, payload.scriptQuestSets,
                    payload.questNumPairs, payload.keepResponses, payload.pollId)
                .pipe(
                    map(PollActions.entirePollLoaded)
                );
        });

}
